export default __webpack_public_path__ + "static/media/pessoas.2d5d0772.svg";